<div class="modal-organization" [class.modal-show]="isOrganizationModalShow"
     [class.modal-hide]="!isOrganizationModalShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <h3>Додати організацію</h3>

  <div class="form-row">
    <label>Найменування організації</label>

    <div [class.border-wrong]="nameError">
      <input
        [(ngModel)]="organization.name"
        (input)="validationOrganizationName()"
        type="text"
        class="input-text"
        autocomplete="off">

      <span class="status" [class.status-error]="nameError">
        {{ nameErrorMessage }}
      </span>
    </div>
  </div>

  <div class="form-row">
    <label>Форма власності</label>

    <select
      [(ngModel)]="organization.type"
      (ngModelChange)="onTypeChange()"
      class="input-text"
      name="organization_type">
      <option value="fop">ФОП</option>
      <option value="tov">ТОВ</option>
    </select>
  </div>

  <div class="form-row">
    <label>{{ organization.type === 'tov' ? 'ЄДРПОУ' : 'РНОКПП' }}</label>

    <div [class.border-wrong]="edrpouError">
      <input
        [(ngModel)]="organization.edrpou"
        (input)="validationOrganizationEdrpou()"
        type="text"
        class="input-text"
        [attr.maxlength]="edrpouLength"
        autocomplete="off">

      <span class="status" [class.status-error]="edrpouError">
        {{ edrpouErrorMessage }}
      </span>
    </div>
  </div>

  <div class="server-error" *ngIf="serverError">
    {{ serverError }}
  </div>

  <button type="button" class="button" (click)="saveOrganization()" [disabled]="isSaving">
    Зберегти
  </button>
</div>

<div class="dark-layer" [class.modal-show]="isDarkBackground" (click)="closeModal()"></div>
